import {
  TYCOON_AVATARS,
  normalizeTycoonAvatarId,
  tycoonAvatarLabel
} from '../../../shared/tycoon-avatars.js';

const ART = Object.freeze({
  fox: `
    <path d="M12 23 18 8l12 10h4L46 8l6 15-4 23c-4 8-11 12-16 12S20 54 16 46Z" fill="#d96b38"/>
    <path d="m18 12 8 8-11 4Z" fill="#f5b38f"/><path d="m46 12-8 8 11 4Z" fill="#f5b38f"/>
    <path d="M19 38c5 0 8 1 13 6 5-5 8-6 13-6-2 10-7 16-13 16s-11-6-13-16Z" fill="#fff7ed"/>
    <circle cx="24" cy="33" r="2.2" fill="#1f2937"/><circle cx="40" cy="33" r="2.2" fill="#1f2937"/>
    <path d="M29 43h6l-3 4Z" fill="#111827"/>
  `,
  panda: `
    <circle cx="18" cy="18" r="10" fill="#1f2937"/><circle cx="46" cy="18" r="10" fill="#1f2937"/>
    <ellipse cx="32" cy="34" rx="22" ry="23" fill="#f8fafc" stroke="#1f2937" stroke-width="2"/>
    <ellipse cx="23" cy="32" rx="7" ry="9" transform="rotate(18 23 32)" fill="#1f2937"/>
    <ellipse cx="41" cy="32" rx="7" ry="9" transform="rotate(-18 41 32)" fill="#1f2937"/>
    <circle cx="24" cy="31" r="2.2" fill="#f8fafc"/><circle cx="40" cy="31" r="2.2" fill="#f8fafc"/>
    <ellipse cx="32" cy="42" rx="5" ry="4" fill="#1f2937"/><path d="M27 47c3 4 7 4 10 0" fill="none" stroke="#1f2937" stroke-width="2.5" stroke-linecap="round"/>
  `,
  tiger: `
    <path d="M13 22 20 9l9 9h6l9-9 7 13-2 24c-4 8-10 12-17 12S19 54 15 46Z" fill="#f59e0b"/>
    <path d="m19 13 6 7-9 3Zm26 0-6 7 9 3Z" fill="#fed7aa"/>
    <path d="M30 19h4l-2 9Zm-11 5 7 5-9 1Zm26 0-7 5 9 1Z" fill="#1f2937"/>
    <circle cx="24" cy="34" r="2.2" fill="#111827"/><circle cx="40" cy="34" r="2.2" fill="#111827"/>
    <ellipse cx="32" cy="44" rx="9" ry="7" fill="#fff7ed"/><path d="M29 42h6l-3 4Z" fill="#111827"/>
  `,
  penguin: `
    <ellipse cx="32" cy="33" rx="21" ry="26" fill="#111827"/>
    <path d="M18 29c2-13 9-18 14-18s12 5 14 18c-4-4-9-6-14-6s-10 2-14 6Z" fill="#f8fafc"/>
    <ellipse cx="32" cy="39" rx="14" ry="16" fill="#f8fafc"/>
    <circle cx="25" cy="27" r="2.2" fill="#111827"/><circle cx="39" cy="27" r="2.2" fill="#111827"/>
    <path d="m32 31 6 4-6 4-6-4Z" fill="#f59e0b"/>
    <path d="M20 56h10l-5 5Z" fill="#f59e0b"/><path d="M34 56h10l-5 5Z" fill="#f59e0b"/>
  `,
  owl: `
    <path d="M13 24 19 9l9 10h8l9-10 6 15-3 25c-4 7-10 10-16 10S20 56 16 49Z" fill="#8b5e3c"/>
    <circle cx="24" cy="33" r="9" fill="#fef3c7"/><circle cx="40" cy="33" r="9" fill="#fef3c7"/>
    <circle cx="24" cy="33" r="4" fill="#111827"/><circle cx="40" cy="33" r="4" fill="#111827"/>
    <path d="m32 38 5 5-5 5-5-5Z" fill="#f59e0b"/>
    <path d="M20 51c7-3 17-3 24 0" fill="none" stroke="#5b3b25" stroke-width="2" stroke-linecap="round"/>
  `,
  koala: `
    <circle cx="15" cy="24" r="12" fill="#94a3b8"/><circle cx="49" cy="24" r="12" fill="#94a3b8"/>
    <circle cx="15" cy="24" r="7" fill="#cbd5e1"/><circle cx="49" cy="24" r="7" fill="#cbd5e1"/>
    <ellipse cx="32" cy="35" rx="21" ry="23" fill="#b6c2cf" stroke="#64748b" stroke-width="2"/>
    <circle cx="24" cy="33" r="2.3" fill="#1f2937"/><circle cx="40" cy="33" r="2.3" fill="#1f2937"/>
    <ellipse cx="32" cy="42" rx="6" ry="8" fill="#334155"/><path d="M27 50c3 3 7 3 10 0" fill="none" stroke="#334155" stroke-width="2" stroke-linecap="round"/>
  `,
  frog: `
    <circle cx="20" cy="22" r="10" fill="#4ade80"/><circle cx="44" cy="22" r="10" fill="#4ade80"/>
    <ellipse cx="32" cy="38" rx="23" ry="20" fill="#4ade80" stroke="#15803d" stroke-width="2"/>
    <circle cx="20" cy="21" r="5" fill="#f8fafc"/><circle cx="44" cy="21" r="5" fill="#f8fafc"/>
    <circle cx="20" cy="21" r="2.3" fill="#111827"/><circle cx="44" cy="21" r="2.3" fill="#111827"/>
    <circle cx="25" cy="39" r="2" fill="#15803d"/><circle cx="39" cy="39" r="2" fill="#15803d"/>
    <path d="M21 47c6 7 16 7 22 0" fill="none" stroke="#166534" stroke-width="2.5" stroke-linecap="round"/>
  `,
  lion: `
    <circle cx="32" cy="33" r="27" fill="#b7791f"/>
    <circle cx="32" cy="34" r="20" fill="#f6c453"/>
    <circle cx="24" cy="32" r="2.3" fill="#1f2937"/><circle cx="40" cy="32" r="2.3" fill="#1f2937"/>
    <ellipse cx="32" cy="42" rx="9" ry="7" fill="#fff1c2"/>
    <path d="M29 40h6l-3 4Z" fill="#5b3417"/>
    <path d="M26 47c4 3 8 3 12 0" fill="none" stroke="#5b3417" stroke-width="2" stroke-linecap="round"/>
    <path d="M18 17 13 8l11 6m22 3 5-9-11 6" fill="#b7791f"/>
  `
});

export function tycoonAvatarSvg(avatarId, {
  className = 'tycoon-avatar-svg',
  title = null,
  fallbackIndex = 0
} = {}) {
  const id = normalizeTycoonAvatarId(avatarId, fallbackIndex);
  const label = title || tycoonAvatarLabel(id, fallbackIndex);
  return `<svg class="${className}" viewBox="0 0 64 64" role="img" aria-label="${label}" focusable="false">${ART[id]}</svg>`;
}

export function tycoonAvatarOptionsMarkup({
  selectedId = null,
  usedIds = [],
  disabled = false,
  dataAttribute = 'data-tycoon-avatar'
} = {}) {
  const used = new Set(usedIds);
  return TYCOON_AVATARS.map((avatar, index) => {
    const isSelected = avatar.id === selectedId;
    const isUsed = used.has(avatar.id) && !isSelected;
    const isDisabled = disabled || isUsed;
    return `
      <button
        type="button"
        class="tycoon-avatar-option${isSelected ? ' is-selected' : ''}${isUsed ? ' is-used' : ''}"
        ${dataAttribute}="${avatar.id}"
        aria-pressed="${isSelected ? 'true' : 'false'}"
        aria-label="${avatar.label}${isUsed ? ' · Đã có người chọn' : ''}"
        title="${avatar.label}${isUsed ? ' · Đã có người chọn' : ''}"
        ${isDisabled ? 'disabled' : ''}
      >
        <span class="tycoon-avatar-option-art">${tycoonAvatarSvg(avatar.id, { fallbackIndex: index })}</span>
        <span class="tycoon-avatar-option-label">${avatar.label}</span>
      </button>
    `;
  }).join('');
}
